import {
  GET_MENU_LINKS_FAILURE,
  GET_MENU_LINKS_REQUEST,
  GET_MENU_LINKS_SUCCESS,
  SET_CURRENT_MENU_SELECTION,
  SET_MENU_COLLAPSED_STATE,
} from '../Constants';
import {SideMenuState} from '../Components/SideBar/types';

type Action = {
  type: string;
  menuLinks?: any;
  menuSelection?: any;
  isCollapsed?: boolean;
  error?: string;
};

const initialState: SideMenuState = {
  menuItems: [],
  currentSelection: '',
  isCollapsed: true,
  loadStatus: 'idle',
};

export default (state: SideMenuState = initialState, action: Action): SideMenuState => {
  switch (action.type) {
    case GET_MENU_LINKS_REQUEST:
      return {...state, loadStatus: 'loading', loadError: undefined};
    case GET_MENU_LINKS_SUCCESS:
      return {...state, menuItems: action.menuLinks || [], loadStatus: 'loaded', loadError: undefined};
    case GET_MENU_LINKS_FAILURE:
      return {...state, loadStatus: 'error', loadError: action.error};
    case SET_CURRENT_MENU_SELECTION:
      return {...state, currentSelection: action.menuSelection};
    case SET_MENU_COLLAPSED_STATE:
      return {...state, isCollapsed: action.isCollapsed ?? state.isCollapsed};
    default:
      return state;
  }
};
